import { createAggregatedClient } from "@smithy/smithy-client";
import { DeleteSessionCommand, } from "./commands/DeleteSessionCommand";
import { GetSessionCommand } from "./commands/GetSessionCommand";
import { PutSessionCommand } from "./commands/PutSessionCommand";
import { RecognizeTextCommand, } from "./commands/RecognizeTextCommand";
import { RecognizeUtteranceCommand, } from "./commands/RecognizeUtteranceCommand";
import { StartConversationCommand, } from "./commands/StartConversationCommand";
import { LexRuntimeV2Client } from "./LexRuntimeV2Client";
const commands = {
    DeleteSessionCommand,
    GetSessionCommand,
    PutSessionCommand,
    RecognizeTextCommand,
    RecognizeUtteranceCommand,
    StartConversationCommand,
};
export class LexRuntimeV2 extends LexRuntimeV2Client {
}
createAggregatedClient(commands, LexRuntimeV2);
